module.exports = __webpack_public_path__ + "img/weekly-summary.c4363bf4.png";